import { User } from '../AuthenticatedView';

const trackEvent = (user: User, track_message: string) => {
  if (user?.isTelemetryEnabled) {
    window.rudderanalytics.track(track_message);
  }
};

export default trackEvent;
